import { render, staticRenderFns } from "./VPSSecurityProfilePwdEdit.vue?vue&type=template&id=4638971f&scoped=true"
import script from "./VPSSecurityProfilePwdEdit.vue?vue&type=script&lang=js"
export * from "./VPSSecurityProfilePwdEdit.vue?vue&type=script&lang=js"
import style0 from "./VPSSecurityProfilePwdEdit.vue?vue&type=style&index=0&id=4638971f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4638971f",
  null
  
)

export default component.exports